import React, { useState } from 'react'
import { NavLink, useNavigate } from "react-router-dom";
import { useFormik} from "formik";
import * as Yup from "yup";
import axios from "axios";
import swal from "sweetalert";
import Logo from '../images/logo.png';

export default function Login() {
  localStorage.removeItem("otpCounter")
  
  const [emailError , setEmailError] = useState('')
  const [passwordError , setPasswordError] = useState('')

  const navigate = useNavigate();
  const validationSchema = Yup.object().shape({
    email: Yup.string().required("Email is required").email("Email is invalid"),
    password: Yup.string()
    .required("Password is required")
    .min(6, "Password must be at least 6 characters")
    .max(40, "Password must not exceed 40 characters"),
  });

  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
    },
    validationSchema,
    onSubmit: async (data) => {
       console.log('data =>>', data)
      await axios
        .post(process.env.REACT_APP_API_KEY + "api/admin/login", data)
        .then((res) => {
          console.log("res ====>", res);
          if (res.status === 200) {
            swal({
              title: "Wow!",
              text: res.data.message,
              icon: "success",
              button: "Okay",
            });
            localStorage.setItem("otpCounter", 59);
            localStorage.setItem("id", res.data.id);
            localStorage.setItem("email", res.data.email);
            localStorage.setItem("password", res.data.password);
            return navigate("/otp-verification");
          } else if (res.status === 201){
            swal("Oops", res.data.message, "error");
          }  
        }).catch(error => {
          if (error.response && error.response.data && error.response.data.errors) {
            const resdata = error.response.data.errors;
            Object.keys(resdata).forEach(function(key) {
              if(key == 'email'){
                setEmailError(resdata[key]);
              }
              if(key == 'password'){
                setPasswordError(resdata[key]);
              }
              console.log('Key : ' + key + ', Value : ' + resdata[key])
            });
          } else {
             console.error("Login API Error: ", error);
          }
          swal("Oops", error.response?.data?.message || "Unauthorized User or Internal Error", "error");
      });
    },
  });

  return (
  <>
    <div className="login">
        <div className="App">
        <img src={Logo} className="logo" alt="Business view - Reports" />
        <form className="form" onSubmit={formik.handleSubmit}>
          <div className="input-group">
            <label htmlFor="email">Email</label>
            <input
                id="email"
                name="email"
                type="email"
                onChange={formik.handleChange}
                value={formik.values.email}
                placeholder="Enter email"
            />
            <div className="text-danger">
              {formik.errors.email || emailError ? formik.errors.email || emailError : null}
            </div>
          </div>
          <div className="input-group">
            <label htmlFor="password">Password</label>
            <input
                id="password"
                name="password"
                type="password"
                onChange={formik.handleChange}
                value={formik.values.password}
                placeholder="Enter password"
            />
            <div className="text-danger">
              {formik.errors.password || passwordError ? formik.errors.password || passwordError : null}
            </div>
          </div>
          <button className="primary">Submit</button>
        </form>
      </div>
    </div>
    </>
  )
}